module.exports = __webpack_public_path__ + "media/assets/images/category/Halloween@2x-a3f672ebada0cc7c81994bf852d798c6.png";